import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EMessagesActionTypes {
  UpdateCount = 'messages/update-count',
}

export type TUpdateMessagesCount = ITypedReduxAction<EMessagesActionTypes.UpdateCount, number>;

export type TMessagesActions = TUpdateMessagesCount;
